import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import mapboxgl from "mapbox-gl";
// import polyline from "@mapbox/polyline";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import * as turf from "@turf/turf";
import _ from "lodash";
import Switch from "react-switch";
import { Label } from "reactstrap";

import * as actionTypes from "./../../../../store/actions/actionTypes";
import classes from "./BoxiMap.module.scss";
import axios from "axios";

import heatmap_worker from "workerize-loader!./../../../../heatmap_worker"; // eslint-disable-line import/no-webpack-loader-syntax
import line_worker from "workerize-loader!./../../../../line_worker"; // eslint-disable-line import/no-webpack-loader-syntax

class BoxiMap extends Component {
  state = {
    position: [-118.240194, 33.8644],
    zoom: 9,
    minZoom: 4,
    maxZoom: 15,
    style: "light-v9?optimize=true",
    loading: false,
    heatmapView: false
  };

  drawing = false;
  mapRef = React.createRef();
  layerIds = [];
  turfPolygons = null;

  removeAllRoutes = (map) => {
    this.layerIds.map((layerId) => {
      if (map.getLayer(layerId)) {
        map.removeLayer(layerId);
        map.removeSource(layerId);
      }
    });
    this.turfPolygons = [];
  };

  drawCampaignRoutes = async (map) => {
    console.log(this.props.campaigns[this.props.selected]);
    if (
      !this.props.campaigns[this.props.selected] ||
      !this.props.campaigns[this.props.selected].name ||
      Object.keys(this.props.campaigns[this.props.selected].vehicles).length === 0
    ) {
      this.setState({
        loading: false
      });
      return;
    }
    this.drawing = true;
    // console.log("start draw");
    let vehicles = this.props.campaigns[this.props.selected].vehicles;
    this.removeAllRoutes(map);
    let boundingBoxExists = await this.buildBoundingBox();
    let allCoordinates = [];
    let workerCount = 0;
    let expectedVehicleCount = Object.keys(vehicles).length;
    let first = true;
    console.log(`expected number of layers ${expectedVehicleCount}`);
    for (const [key, vehicle] of Object.entries(vehicles)) {
      // web workers
      let workerInstance;
      if (this.state.heatmapView){
        workerInstance = heatmap_worker();
      }
      else{
        workerInstance = line_worker();
      }
      // listen for result of web worker, then add it as layer to map
      workerInstance.addEventListener("message", (message) => {
        // console.log(`Message from worker: ${message.data}`);
        if (message.data && !message.data.type) {
          // console.log(`Adding ${message.data.id}`);
          workerCount++;
          if (message.data.layer) {
            // center map to first coordinate drawn while drawing other routes
            if (first && message.data.coords[0]) {
              map.flyTo({
                center: message.data.coords[0],
                essential: true
              });
              first = false;
            }
            // concat all coordinates to construct bbox for default zoom
            allCoordinates = allCoordinates.concat(message.data.coords);
            this.layerIds.push(message.data.id);
            // add layer
            console.log("Layer: " + JSON.stringify(message.data.layer));
            map.addLayer(message.data.layer);
            console.log("adding layer");
          }
          // when worker count is equal to expected vehicle count, adding layers is finished
          if (workerCount === expectedVehicleCount) {
            // set map bounds to line string
            let bounds = allCoordinates.reduce(
              (bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(allCoordinates[0], allCoordinates[0])
            );
            // only set bounds if it exists
            if (bounds._sw) {
              map.fitBounds(bounds, {
                padding: 175
              });
            }
            this.setState({
              loading: false
            });
            // console.log("finish draw");
            this.drawing = false;
          }
          workerInstance.terminate();
        }
      });
      // start web worker
      workerInstance.generateLayer(vehicle, boundingBoxExists, this.turfPolygons, this.props.startDate, key);

      // old code that was ported to the web worker worker.js file
      // // draw polylines
      // let features = [];
      // vehicle.paths.map((path) => {
      //   // convert start time to unix milliseconds
      //   if (new Date(path.start).getTime() >= this.props.startDate) {
      //     let coordinates = [];
      //     if (path.polyline) {
      //       polyline.decode(path.polyline).map((point) => {
      //         let reversedPoint = [point[1].toFixed(6), point[0].toFixed(6)];
      //         // if bounding box exists and was build, skip if point is not in polygon
      //         // if (coordCount[reversedPoint] > 4) {
      //         //   skippedCoordCount++;
      //         // }
      //         if (boundingBoxExists && !this.inBoundingBox(reversedPoint)) {
      //           if (coordinates.length > 0) {
      //             features.push({
      //               type: "Feature",
      //               properties: {},
      //               geometry: {
      //                 coordinates: coordinates,
      //                 type: "LineString"
      //               }
      //             });
      //             allCoordinates = allCoordinates.concat(coordinates);
      //             coordinates = [];
      //           }
      //         }
      //         coordinates.push(reversedPoint);
      //         // if (reversedPoint in coordCount) {
      //         //   coordCount[reversedPoint]++;
      //         // } else {
      //         //   coordCount[reversedPoint] = 1;
      //         // }
      //       });
      //       allCoordinates = allCoordinates.concat(coordinates);
      //       features.push({
      //         type: "Feature",
      //         properties: {},
      //         geometry: {
      //           coordinates: coordinates,
      //           type: "LineString"
      //         }
      //       });
      //     }
      //   }
      // });
      // if (features.length > 0) {
      //   let layerId = `vehicle-${key}`;
      //   this.layerIds.push(layerId);
      //   let geoJSON = {
      //     type: "geojson",
      //     data: {
      //       type: "FeatureCollection",
      //       features: features
      //     },
      //     buffer: 16,
      //     maxzoom: 11,
      //     tolerance: 0.5
      //   };
      //   map.addLayer({
      //     id: layerId,
      //     type: "line",
      //     source: geoJSON,
      //     layout: {
      //       "line-join": "round",
      //       "line-cap": "round"
      //     },
      //     paint: {
      //       "line-color": vehicle.color,
      //       "line-width": 6,
      //       "line-opacity": 0.25
      //     }
      //   });
      //   console.log("add layer");
      // }
      // // for (let [key, count] of Object.entries(coordCount)) {
      // //   if (count > 4) {
      // //     console.log(key, count);
      // //   }
      // // }
      // // break;
    }
  };

  inBoundingBox = (point) => {
    for (let polygon of this.turfPolygons) {
      if (turf.booleanPointInPolygon(turf.point(point), polygon)) {
        return true;
      }
    }
    return false;
  };

  buildBoundingBox = async () => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${this.props.selected}/bounding_box`, {
        withCredentials: true
      });
      if (res.status === 200 && res.data.bounding_box && res.data.bounding_box[0].bounding_box_id) {
        let exists = false;
        res.data.bounding_box.map((box) => {
          this.turfPolygons.push(turf.polygon([box.points]));
          exists = true;
        });
        return exists;
      }
    } catch (err) {
      console.log(err);
    }
    return false;
  };
  switchChangeHandler = (checked) =>{
    this.setState({
      heatmapView: checked,
      loading: true
    }, () => {
      this.drawCampaignRoutes(this.map);
    });
    }
  componentDidUpdate(prevProps, prevState, snapshot) {
    let prevVehicleCount = prevProps.campaigns[prevProps.selected]
      ? Object.keys(prevProps.campaigns[prevProps.selected].vehicles).length
      : null;
    let currentVehicleCount = this.props.campaigns[this.props.selected]
      ? Object.keys(this.props.campaigns[this.props.selected].vehicles).length
      : null;
    // console.log("potential update");
    // console.log(`loading: ${this.state.loading}`);
    // console.log(prevVehicleCount !== currentVehicleCount);
    // console.log(prevProps.campaigns[prevProps.selected]);
    // console.log(this.props.campaigns[this.props.selected]);
    if (
      !this.state.loading &&
      !this.drawing &&
      (prevProps.selected !== this.props.selected ||
        prevProps.startDate !== this.props.startDate ||
        prevProps.updateCampaign !== this.props.updateCampaign ||
        prevVehicleCount !== currentVehicleCount)
    ) {
      // console.log("potential draw");
      this.setState({ loading: true }, () => {
        this.drawCampaignRoutes(this.map);
      });
    }
  }

  componentDidMount() {
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
    // intial map setup
    const map = new mapboxgl.Map({
      container: this.mapRef,
      style: "mapbox://styles/mapbox/" + this.state.style,
      center: this.state.position,
      zoom: this.state.zoom,
      minZoom: this.state.minZoom,
      maxZoom: this.state.maxZoom
    });

    map.on("load", () => {
      setTimeout(() => {
        if (!this.drawing && this.layerIds.length === 0) {
          this.drawCampaignRoutes(map);
        }
      }, 100);
    });

    const nav = new mapboxgl.NavigationControl();
    map.addControl(nav, "bottom-right");
    this.map = map;
    this.props.setBoxiMap(map);
  }

  render() {
    const style = {
      display: this.state.loading ? "block" : "none"
    };
    const heatMapToggleDisplay = {
      display: window.location.pathname.includes('/admin/')? "flex" : "none"
    }
    return (
      <Fragment>
      {/* <div className={classes.heatmapDiv} style={heatMapToggleDisplay} >
      <Label for="hmtoggle">Heatmap View</Label>
      <Switch
      id="hmtoggle"
      className={classes.heatmapToggle}
      checked={this.state.heatmapView}
      onChange={this.switchChangeHandler} />
      </div> */}
        <div id="map" className={classes.map} ref={(el) => (this.mapRef = el)} />
        <div className={classes.loadWrapper} style={style}>
          <div className={classes.loaderLabel}>Drawing Routes...</div>
          <div className={classes.loader}>Drawing...</div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaigns: state.clientDashboard.campaigns,
    selected: state.clientDashboard.selected,
    startDate: state.clientDashboard.startDate,
    updateCampaign: state.clientDashboard.updateCampaign
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBoxiMap: (map) => {
      dispatch({
        type: actionTypes.SET_BOXI_MAP,
        map: map
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoxiMap);
